import styled from 'styled-components'

export const Shape = styled.div`
  width: 100%;
  box-sizing: border-box;
  ${props => props.theme};
`